import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';
import { Navigate } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const OfficersPage = lazy(() => import('../pages/officers/page'));
const SponsorsPage = lazy(() => import('../pages/sponsors/page'));
const FootballPage = lazy(() => import('../pages/programs/football/page'));
const CheerPage = lazy(() => import('../pages/programs/cheer/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const VolunteerPage = lazy(() => import('../pages/volunteer/page'));
const GearPage = lazy(() => import('../pages/gear/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/programs/football',
    element: <FootballPage />,
  },
  {
    path: '/programs/cheer',
    element: <CheerPage />,
  },
  {
    path: '/officers',
    element: <OfficersPage />,
  },
  {
    path: '/sponsors',
    element: <SponsorsPage />,
  },
  {
    path: '/events',
    element: <EventsPage />,
  },
  {
    path: '/volunteer',
    element: <VolunteerPage />,
  },
  {
    path: '/gear',
    element: <GearPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;